import React from 'react'
import { Flex } from '@components'
import { Form, Button, Radio } from 'antd'
import SiderMenu from '@pages/Assembly/siderMenu'
import Breadcrumb from '@pages/Assembly/Breadcrumb'
import TitleTop from '@pages/Assembly/titleTop'
import { message } from 'antd/lib/index'
import NHFetch from '../../../../utils/NHFetch'
import NextButton from '@pages/SelfHelp/common/nextIndex'
import { getLoginUser } from '@utils/NHCore'
import CommonTip from '../common'
import { mkbz } from '@pages/Assembly/siderMenu/menuObj'
import Hint from '@pages/SelfHelp/common/hint'
import { Scrollbars } from 'react-custom-scrollbars'
import './index.css'

const FormItem = Form.Item
const basicUrl = 'api/zhxg-yxwz'

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 }
}

@Form.create()
export default class CreditCardConfirm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      xsid: getLoginUser().userId,
      zzbdhjid: this.getUrlParams('pkid'),
      mkbz: 'GD054',
      hjmc: '玉兰龙卡办卡确认',
      editable: false,
      nextUrl: '', //左侧菜单加载完后传进来
      search: '',
      operable: true, //是否显示环节
      nonOperationalData: {}, //不可操作的数据
      undertakingHtml: '', //办卡确认书富文本
      xssfytj: '', //学生是否已提交
      formData: {}, //学生已提交的办卡确认信息
      isRender: false, //是否渲染
      hasScrolledToBottom: false, //是否已滚动至底部
      qrzt: '', //确认选择状态
    }
  }

  //渲染前获取信息
  componentDidMount() {
    this.queryQztjAndYlhj()
    this.getRzsxPz()
  }

  //查询前置条件和依赖环节
  queryQztjAndYlhj = () => {
    const { zzbdhjid } = this.state
    let xsid = getLoginUser() ? getLoginUser().userId : ''
    if (!xsid) {
      this.setState({
        nonOperationalData: { nologin: true },
        operable: false
      })
      return
    }
    NHFetch('/zzbd/queryQztjAndYlhj', 'GET', { xsid: xsid, zzbdhjid }).then(res => {
      if (res && res.data) {
        let kfsj = res.data['kfsj']
        let ylhj = res.data['ylhj']
        let qzhj = res.data['qzhj']
        let nohj = res.data['nohj']
        this.setState({ nonOperationalData: res.data })
        if (kfsj && kfsj['YXSJ'] != '1') {
          this.setState({ operable: false })
        }

        if (ylhj && ylhj.length > 0) {
          this.setState({ operable: false })
        }

        if (qzhj && qzhj.length > 0) {
          this.setState({ operable: false })
        }
        if (nohj) {
          this.setState({ operable: false })
        }
      }
    })
  }

  getQueryString = name => {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
  }

  setMenuList = menuList => {
    let nextCount = 0
    let bz = this.state.mkbz
    menuList.map((elem, index) => {
      if (elem.HJDM == bz) {
        let hjmc = elem.HJMC
        this.setState({ hjmc: hjmc })
        nextCount = index + 1
        return
      }
    })
    let menu = menuList[nextCount]
    if (menu) {
      let hjdm = menu.HJDM
      if (hjdm.indexOf('GD') == 0) {
        let gdUrl = mkbz[hjdm]
        this.setState({
          nextUrl: gdUrl,
          search: 'pkid=' + menu.PKID
        })
      } else if (hjdm.indexOf('ZDY') == 0) {
        let zdyUrl = '/customLink'
        this.setState({
          nextUrl: zdyUrl,
          search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
        })
      }
    } else {
      this.setState({
        nextUrl: '',
        search: ''
      })
    }
  }

  getUrlParams = param => {
    return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
  }

  //重新加载菜单
  reloadMenu = () => {
    this.refs.siderMenu.reloadMenuList()
  }

  //保存
  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return
      }

      const { qrzt } = values
      if (!qrzt) {
        message.warning('请选择确认项')
        return
      }

      this.saveCreditCardConfirm({ confirm: '1', qrzt })
    })
  }

  // 获取办卡确认书配置
  getRzsxPz = () => {
    const { xsid } = this.state
    NHFetch(`${basicUrl}/zzbd/yllkbkqrs/getYllkbkqrPz?xsid=${xsid}`, 'GET').then(res => {
      if (res && res.code === 200) {
        let nr = res.data?.nr ?? '';
        let xssfytj = res.data?.xssfytj ?? '0';
        this.setState({
          undertakingHtml: nr,
          xssfytj: xssfytj,
          editable: xssfytj === '0',
          hasScrolledToBottom: false,
        })

        if (xssfytj === '1') {
          // 已提交
          this.getXxRzsx()
        } else {
          this.setState({ isRender: true }, () => {
            this.checkScrollPosition()
          })
        }
      }
    })
  }

  // 滚动事件处理
  handleUndertakingScroll = (values) => {
    const { scrollTop, scrollHeight, clientHeight } = values
    if (scrollHeight <= clientHeight || scrollTop + clientHeight >= scrollHeight - 5) {
      this.setState({ hasScrolledToBottom: true })
    }
  }

  // 检查内容是否未超出容器（无需滚动即可勾选）
  checkScrollPosition = () => {
    setTimeout(() => {
      if (this.scrollbarRef) {
        const scrollHeight = this.scrollbarRef.getScrollHeight()
        const clientHeight = this.scrollbarRef.getClientHeight()
        if (scrollHeight <= clientHeight) {
          this.setState({ hasScrolledToBottom: true })
        }
      }
    }, 100)
  }

  // 获取学生办卡确认信息
  getXxRzsx = () => {
    const { xsid } = this.state
    NHFetch(`${basicUrl}/zzbd/yllkbkqrs/getXsYllkbkqrs/${xsid}`, 'GET').then(res => {
      if (res && res.code === 200) {
        this.setState({
          formData: res.data || {},
          qrzt: (res.data && res.data.qrzt) || '',
          isRender: true
        })
      }
    })
  }

  // 保存办卡确认信息
  saveCreditCardConfirm = params => {
    const { xsid, zzbdhjid } = this.state
    const token = window.sessionStorage.getItem('access_token')
    const formData = new FormData()
    formData.append('zzbdhjid', zzbdhjid)
    formData.append('confirm', params.confirm)
    formData.append('qrzt', params.qrzt)
    formData.append('czpt', '1') //操作平台：PC端

    fetch(`${basicUrl}/zzbd/yllkbkqrs/saveXsYllkbkqrs`, {
      method: 'POST',
      headers: { token: token, loginUserId: xsid },
      body: formData
    })
        .then(async response => {
          const res = await response.json()
          if (res && res.code === 200) {
            if (res.data == '1') {
              message.success('确认成功！')
              this.getRzsxPz()
              this.reloadMenu()
            } else {
              message.error('确认失败，请重试！')
            }
          } else {
            message.error('确认失败，请重试！')
          }
        })
        .catch(() => {
          message.error('确认失败，请重试！')
        })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { editable, formData, isRender, undertakingHtml, hasScrolledToBottom, qrzt } = this.state

    return (
        <div>
          {this.state.operable ? (
              <Flex className="w1180 mt-20" align="start">
                <SiderMenu ref={'siderMenu'} setMenuList={this.setMenuList} title="自助报到" mkbz={this.state.mkbz} menuType="自助报到" />
                <Flex.Item className="page_con_r">
                  <Breadcrumb noLine list={[{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]} />
                  <div className="box" style={{ paddingBottom: 0 }}>
                    <Hint />
                    <TitleTop title={this.state.hjmc} extra={false} />
                    {isRender && (
                        <Form onSubmit={this.handleSubmit}>
                          <div className="p-sw" style={{ paddingBottom: 0 }}>
                            {undertakingHtml && (
                                <div style={{ marginBottom: '20px' }}>
                                  <Scrollbars
                                      ref={el => (this.scrollbarRef = el)}
                                      onScrollFrame={this.handleUndertakingScroll}
                                      style={{
                                        height: 500,
                                        border: '1px solid #e8e8e8',
                                        padding: '20px',
                                        backgroundColor: '#fafafa'
                                      }}
                                  >
                                    <div className="signature" dangerouslySetInnerHTML={{ __html: undertakingHtml }} />
                                  </Scrollbars>
                                </div>
                            )}

                            <FormItem {...formItemLayout} label="">
                              {editable ? (
                                  hasScrolledToBottom ? (
                                    getFieldDecorator('qrzt', {
                                      initialValue: qrzt || undefined,
                                      rules: [
                                        {
                                          required: true,
                                          message: '请选择确认项'
                                        }
                                      ],
                                    })(
                                      <Radio.Group onChange={e => this.setState({ qrzt: e.target.value })}>
                                        <Radio value="1" style={{ display: 'block', marginBottom: 8 }}>我已申办玉兰龙卡</Radio>
                                        <Radio value="2" style={{ display: 'block' }}>不申办，我已完成建行卡号维护</Radio>
                                      </Radio.Group>
                                    )
                                  ) : (
                                    <div style={{ color: 'rgba(0, 0, 0, 0.45)' }}>请滚动阅读至底部后选择</div>
                                  )
                              ) : (
                                  <Radio.Group value={formData.qrzt} disabled>
                                    <Radio value="1" style={{ display: 'block', marginBottom: 8 }}>我已申办玉兰龙卡</Radio>
                                    <Radio value="2" style={{ display: 'block' }}>不申办，我已完成建行卡号维护</Radio>
                                  </Radio.Group>
                              )}
                            </FormItem>

                            <div
                                className="text-center"
                                style={{ marginTop: '20px', marginBottom: '-40px' }}
                            >
                              {editable && (
                                  <Button type="primary" htmlType="submit" disabled={!qrzt}>
                                    保存
                                  </Button>
                              )}

                              {!editable && (
                                  <Button type="primary" onClick={() => this.setState({ editable: true, hasScrolledToBottom: false, qrzt: '' })}>
                                    修改
                                  </Button>
                              )}

                              <NextButton nextUrl={this.state.nextUrl} search={this.state.search} />
                            </div>
                          </div>
                        </Form>
                    )}
                  </div>
                </Flex.Item>
              </Flex>
          ) : (
              <CommonTip hjmc={'玉兰龙卡办卡确认'} key={'GD054'} mkbz="GD054" nonOperationalData={this.state.nonOperationalData} />
          )}
        </div>
    )
  }
}